import { render, staticRenderFns } from "./CheckboxToogle.vue?vue&type=template&id=66410fe2&"
import script from "./CheckboxToogle.vue?vue&type=script&lang=js&"
export * from "./CheckboxToogle.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxToogle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports